import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import VideoPlayerIcon from "../../assets/svgs/video-player-icon.svg";

const Hero = ({ content, btnExploreText, exchangeLink }) => {
  const {
    node: { acfHeroSections: _content },
  } = content.edges[0];

  const data = useStaticQuery(graphql`
    query {
      zipworldIcon: file(
        relativePath: { eq: "images/menus/icons/zipworld.svg" }
      ) {
        publicURL
      }
    }
  `);

  return (
    <div id="hero" className="mt-auto">
      <div className="col hero-img w-100 h-auto" />
      <div className="hero-content text-center">
        <div className="container d-flex flex-column justify-content-center">
          <div className="product-name mb-3">
            <img
              className="mr-1"
              src={data.zipworldIcon.publicURL}
              alt=""
              height={32}
              width={32}
            />
            <span>ZipWorld</span>
          </div>
          <h1 dangerouslySetInnerHTML={{ __html: _content.hsMainHeading }} />
          <div
            className="hero-content-description align-self-center mt-3"
            dangerouslySetInnerHTML={{ __html: _content.hsMainText }}
          />
          <div className="mt-4">
            <a
              className="button button-primary mx-2 mb-3 mb-md-0"
              href={`${exchangeLink}/zipworld`}
              target="_blank"
              rel="noreferrer noopener"
            >
              {btnExploreText}
            </a>
            <a
              className="button btn-watch-video mx-2"
              href={_content.hsButtonLink}
              target="_blank"
              rel="noreferrer noopener"
            >
              <VideoPlayerIcon className="mr-2" />
              {_content.hsButtonText}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
